import { getPanelsIds } from 'common/api/v1/products';

import {
    FETCH_PANELS_IDS,
    FETCH_PANELS_IDS_FAILURE,
    FETCH_PANELS_IDS_SUCCESS,
} from '../actionTypes';
import { addPanelsModalActions } from '../reducer';

export default () => (dispatch) => {
    dispatch(addPanelsModalActions[FETCH_PANELS_IDS]());

    getPanelsIds()
        .then((response) =>
            dispatch(
                addPanelsModalActions[FETCH_PANELS_IDS_SUCCESS](
                    response.data.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                addPanelsModalActions[FETCH_PANELS_IDS_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
